import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useAdminPermissions } from '../contexts/AdminPermissionsContext';
import { ROUTE_PERMISSIONS } from '../constants/adminPermissions';

/**
 * Renders children only if the current admin route is allowed by the user's permissions.
 * If not allowed, redirects to /admin. Use inside AdminPermissionsProvider (e.g. wrapping Outlet).
 */
export default function AdminPermissionGuard({ children }) {
  const location = useLocation();
  const { canAccessRoute, loading } = useAdminPermissions();

  if (loading) {
    return <p>Loading...</p>;
  }

  const pathname = location.pathname.replace(/^\/admin\/?/, '') || '';
  const pathSegment = pathname.split('/')[0] || '';
  const required = ROUTE_PERMISSIONS[pathSegment];
  if (required !== undefined && required !== null && !canAccessRoute(pathSegment)) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}
